module.exports = __webpack_public_path__ + "img/f0a92b2ee217bda7864d381c810b4daa.png";